/* S12 · CRITIC FLAGS — Skippy proactively surfacing what the OFFLINE critic engine
 * (engine/critic.py, Engine B) flagged: scored, evidenced, question-framed HYPOTHESES
 * Nick PULLS (never pushed). Read-only surface — renders Stamped<Flag[]> into Pop-Bento
 * cards, stamps every card, and shows the honest offline banner when the critic hasn't
 * run yet. Nothing here is ever fabricated. */
import { getStore } from '../store';
import { esc, stampLine, surfaceTitle, card, loading, note, offlineBanner } from '../components/ui';

export async function renderFlags(root: HTMLElement): Promise<void> {
  root.innerHTML = surfaceTitle('Flags') + loading();
  const s = await getStore().getCritic();

  // Honest offline: the critic engine hasn't produced flags yet — say so, don't fake.
  if (s.freshness === 'offline') {
    root.innerHTML =
      surfaceTitle('Flags') +
      offlineBanner(s.source) +
      note('The critic engine hasn’t produced any flags yet — nothing to review.') +
      stampLine(s);
    return;
  }

  const cards = s.data
    .map((f) => {
      // score → severity dot: 7+ strong stakes (attention), 5–6 (watch), else (good).
      const dot = f.score_1_to_10 >= 7 ? 'attention' : f.score_1_to_10 >= 5 ? 'watch' : 'good';
      const evidence = f.evidence
        .map((e) => `<li>${esc(e.text)} <span class="label">${esc(e.source_id)}</span></li>`)
        .join('');
      const systems = f.systems_touched.length
        ? `<div class="label">systems: ${esc(f.systems_touched.join(', '))}</div>`
        : '';
      return card(
        `<span class="pill"><span class="dot ${dot}"></span>score ${f.score_1_to_10}/10 · ${esc(
          f.confidence,
        )}</span>
         <h3>${esc(f.title)}</h3>
         <p class="label">Evidence</p>
         <ul style="margin:4px 0 0;padding-left:18px">${evidence}</ul>
         <p><strong>${esc(f.question)}</strong></p>
         ${systems}`,
        'wide',
      );
    })
    .join('');

  root.innerHTML = surfaceTitle('Flags') + cards + stampLine(s);
}
